<script>
  import { createEventDispatcher, onMount } from "svelte";
  import AddressPicker from "../HTMLElements/AddressPicker.svelte";
  import Modal from "../HTMLElements/Modal.svelte";
  import VerifySMS from "../SMSVerification.svelte";
  import { TitleList, UpdateUserStore,User } from "../../store.js";
  import Select from "../HTMLElements/Select.svelte";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import * as validate from "../Utils/ValidateFormFIelds.js";
	import * as ExtractMsg from "../Utils/UserMsgFromInvalidResponse.js";
  import Field from "../FormField.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import Email from "../HTMLElements/Email.svelte";
  import Phone from "../HTMLElements/PhoneNumber.svelte";
  import Password from "../HTMLElements/PasswordSetter.svelte";
  import Help from "../help.svelte";
  import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
  import wrappedFetch from "../../wrappedFetch.js";

  export let showModal = false;
  let emailChanged = false;
  let showSuccessMessage = false;
  let submittedApplications =[];
  let submittedLateApplications =[];

  export let showMobileVerification = false;
  let dispatch = createEventDispatcher();
  let DefaultUserDetails;
  let isValid = true;
  let errMsg = "";
  let wrappedObj; //= $UpdateUserStore;
  let updatingUser = false;
  let buttonText='Cancel';
  let showCheckBoxModal = false;

  let username = "edituserdetails";

  //  UserDetails.confirmEmail=UserDetails.email;
  DefaultUserDetails = JSON.parse(JSON.stringify($UpdateUserStore));
  $UpdateUserStore.confirmEmail = $UpdateUserStore.email;
  $UpdateUserStore.confirmPassword = "";
  $UpdateUserStore.password = "";

  if($UpdateUserStore.address && ($UpdateUserStore.address.addr == "" ||!$UpdateUserStore.address.addr )) $UpdateUserStore.address= null;
  wrappedObj = objectWrapper.wrapObject($UpdateUserStore);
  // if(wrappedObj)
  // {   
  //   wrappedObj.homePhone.value = wrappedObj.homePhone.value && wrappedObj.homePhone.value !=''?wrappedObj.homePhone.value.replace(' ',''):wrappedObj.homePhone.value;
  //   wrappedObj.workPhone.value = wrappedObj.workPhone.value && wrappedObj.workPhone.value !=''?wrappedObj.workPhone.value.replace(' ',''):wrappedObj.workPhone.value;
  //   wrappedObj.mobile.value = wrappedObj.mobile.value  && wrappedObj.mobile.value !=''?wrappedObj.mobile.value.replace(' ',''):wrappedObj.mobile.value;
	// }
  if (wrappedObj) {
  // Remove all spaces first
  ['homePhone', 'workPhone', 'mobile'].forEach(function(field) {
    let val = wrappedObj[field]?.value;
    if (val && val.trim() !== '') {
      wrappedObj[field].value = val.replace(/\s+/g, '');
    }
  });
}
	let emailinUse = false;
	let isEmailInUse = async () => {
	const response = await wrappedFetch("user/isemailinuse?email=" + wrappedObj.email.value);
	return await response.json();
	};

	async function saveUser() {
	UpdateUserStore.set(objectWrapper.unwrapObject(wrappedObj));

	// wrappedObj.isMemberOfCrownService.value = wrappedObj.isMemberOfCrownService.value  ? "Y" : "N";
	const updateUserURL = "user/updateparent";

	const response = await wrappedFetch(updateUserURL, {
	method: "post",
	body: JSON.stringify($UpdateUserStore),
	headers: {
	"Content-Type": "application/json"
	}
	});
	return await response.json();
	}

	const handleCancel = e => {
    e.preventDefault();
    UpdateUserStore.set(DefaultUserDetails);
    dispatch("pageChange", "/useraccount/details");
	};

	const saveDetails = async e => 
  {
    e.preventDefault();

    updatingUser = true;

    // Title is required — check explicitly in case the Select component
    // doesn't participate in wrappedObj validation.
    if (!wrappedObj.title.value || (typeof wrappedObj.title.value === 'object' && !wrappedObj.title.value.label)) {
      wrappedObj.title.isDirty = true;
      wrappedObj.title.isValid = false;
      errMsg = "Please select a title.";
      updatingUser = false;
      return;
    }

    if (!validate.validate(wrappedObj)) {
	      errMsg = "Please check required fields have valid data.";
        updatingUser = false;
        return;
    }

    if (wrappedObj.email.value != DefaultUserDetails.email) 
    {
      emailinUse = await isEmailInUse();
      if(emailinUse)
			{
        errMsg = 'Email address is already in use.';
        updatingUser = false;
				return;
			}
    }

    let save = await saveUser();

    if (save.isVerifySMS) 
    {
      $User.mobile = $UpdateUserStore.mobile;
      showMobileVerification = true;
      updatingUser = false;
      return;
    } 

    if (!save.success) 
    {
        UpdateUserStore.set(DefaultUserDetails);
        errMsg = ExtractMsg.ExtractMsgsFromInvalidResponse (save, 
                             "Unfortunately, we are unable to save your changes. Please contact our <a href='https://www.eadmissions.org.uk/support/' target='_blank' style='text-decoration:underline'>technical support team</a> if this problem is persistent.", 
                              "Problem saving: ");
        updatingUser = false;
        return;
    }

    // save.success is true, the save worked
    emailChanged = save.isEmailChanged;
    $User.mobile = $UpdateUserStore.mobile;
    $User.isMobileValidated = $UpdateUserStore.mobileValidated;
    if(emailChanged)
      $User.isEmailValidated='N';

    submittedApplications= save.applications || [];
    submittedLateApplications = save.lateApplications || [];
    showSuccessMessage = true;
    updatingUser = false;

   
   // dispatch("pageChange", "/user/home");
	};

	$: cannotReceiveSms = !wrappedObj.mobile.isValid || !wrappedObj.mobile.value || wrappedObj.mobile.value == '';

</script>

<h1 class="title is-3">Updating your details</h1>
<p class="subtitle is-5">
  Please check, change and confirm your details are correct.
</p>
<p>Required fields <span style="color: rgb(204, 4, 4);">*</span>  </p>

<form
  action=""
  on:submit={e => {
    e.preventDefault();
  }}>
  <div class="box">
    <Field label="Title" isRequired={true}>
      <span slot="inputField">
        <Select
          items={TitleList}
          bind:selectedValue={wrappedObj.title.value}
          bind:isValid={wrappedObj.title.isValid}
          bind:isDirty={wrappedObj.title.isDirty}
          selectedValueText="label"
          label="your title"
          placeholder="Select your title"
          isRequired="true" />
      </span>
    </Field>
    <Field label="First Name">
      <span slot="inputField">
        <TextBox
          placeholder="First name"
          isRequired="true"
          bind:text={wrappedObj.forename.value}
          bind:isValid={wrappedObj.forename.isValid}
          bind:isDirty={wrappedObj.forename.isDirty}
          label="your first name" />
      </span>
    </Field>
    <Field label="Last Name">
      <span slot="inputField">
        <TextBox
          placeholder="Last name"
          isRequired="true"
          bind:text={wrappedObj.surname.value}
          bind:isValid={wrappedObj.surname.isValid}
          bind:isDirty={wrappedObj.surname.isDirty}
          label="your last name" />
      </span>
    </Field>

    <Field label="Address">

      <span slot="inputField">
        <AddressPicker
          bind:selectedAddress={wrappedObj.address.value}
          bind:isValid={wrappedObj.address.isValid}
          bind:isAddressDirty={wrappedObj.address.isDirty}
          bind:isPostcodeDirty={wrappedObj.postcode.isDirty}
          bind:isPostcodeValid={wrappedObj.postcode.isValid}
          bind:username={username}
          isRequired="true"
          label="postcode" />

      </span>
    </Field>
    <!--span style="font-size:small; color:grey">Local Authority: {$UpdateUserStore.address.laName}</span-->
  </div>
  <div class="box">
    <Field
      label="Contact details" isTitle={true}
      isRequired={false}>
      <span slot="inputField">
        <Field label="Email Address">
          <span slot="inputField">
            <Email
              placeholder="email@domain.com"
              isRequired="true"
              bind:email={wrappedObj.email.value}
              bind:isValid={wrappedObj.email.isValid}
              bind:isDirty={wrappedObj.email.isDirty}
              bind:isInUse={emailinUse}
              on:blur={ ()=>{emailinUse = false; wrappedObj.email.isDirty = true;}}
              label="email address" />
          </span>
        </Field>
        <Field label="Confirm Email Address">
          <span slot="inputField">
            <Email
              placeholder="Re-enter email address"
              isRequired="true"
              bind:email={wrappedObj.confirmEmail.value}
              bind:isValid={wrappedObj.confirmEmail.isValid}
              bind:isDirty={wrappedObj.confirmEmail.isDirty}
              bind:emailToCompare={wrappedObj.email.value}
              label="email address" />
          </span>
        </Field>
    
        <Field label="Mobile Phone Number" isRequired={true} >
          <span slot="inputField">
            <Phone
              placeholder="07xxx xxxxxx"
              isRequired="true"
              bind:number={wrappedObj.mobile.value}
              bind:isValid={wrappedObj.mobile.isValid}
              bind:isDirty={wrappedObj.mobile.isDirty}
              isMobile="true"
              isWork="false"
              label="mobile phone number" />
          </span>
        </Field>
        <!-- {#if !wrappedObj.mobile.value || wrappedObj.mobile.value == ""}
        <p class="help" style="margin-left: 2px;">Please enter your mobile number if you would like to opt into receiving SMS alerts</p>
        {/if} -->

        <Field label="Landline Phone Number" isRequired={false} >
          <span slot="inputField">
            <Phone
              placeholder="020 1234 5678"
              isRequired="false"
              bind:number={wrappedObj.homePhone.value}
              bind:isValid={wrappedObj.homePhone.isValid}
              bind:isDirty={wrappedObj.homePhone.isDirty}
              isMobile="false"
              isWork="false"
              label="landline phone number" />
          </span>
        </Field>
        <Field label="Work Phone Number" isRequired={false} >
          <span slot="inputField">
            <Phone
              placeholder="020 9876 5432"
              isRequired="false"
              bind:number={wrappedObj.workPhone.value}
              bind:isValid={wrappedObj.workPhone.isValid}
              bind:isDirty={wrappedObj.workPhone.isDirty}
              isMobile="false"
              isWork="true"
              label="work phone number" />
          </span>
        </Field>
      </span>
    </Field>
  </div>
  <div class="box">
    <h1 class="title is-5">Options</h1>
    <div style="display:none">
      <CheckBox
        label="Opt into receiving SMS alerts"
        bind:checked={wrappedObj.receiveSMS.value} 
        bind:isDisabled={cannotReceiveSms}/>
    </div>
    <CheckBox
      helpId="help36"
      label=" I am a Crown Servant"
      bind:checked={wrappedObj.isMemberOfCrownService.value}
      bind:showModal={showCheckBoxModal}
      on:change={()=>{if (wrappedObj.isMemberOfCrownService.value) showCheckBoxModal = true;}} />
  </div>
  {#if errMsg != ''}
    <hr />
    <div class="notification is-invalid">
          <p class="help" style="margin-bottom:0px">{@html errMsg}</p>
        </div>
    <hr />
  {/if}

  <div style="text-align: right;">
    <button on:click={handleCancel} class="button" style="margin-right:10px;">
      Cancel
    </button>
    <button
      on:click={saveDetails}
      class="button is-primary {updatingUser ? 'is-loading' : ''}"
      disabled={updatingUser}>
      Save
    </button>
  </div>
</form>

<Modal bind:showModal >
   <Help
      helpId="Help36"
      showSearchOption={false}
      showContent={false}
      doAnimation={false} />
</Modal>


  <VerifySMS mobile={$UpdateUserStore.mobile} bind:showModal={showMobileVerification}   on:close={()=>dispatch('pageChange', '/useraccount/details')} on:verifyLater={()=>{wrappedObj.receiveSMS.value = false;$User.isMobileValidated = 'N'}} />


<Modal bind:showModal={showSuccessMessage}>
<div style="padding:1em;">
  <h4 class="title is-5">Your details have been updated successfully!</h4>
  {#if emailChanged}      
    <p>As you have updated your email address, a validation email has now been sent to your new email address. Please find the email and click the link to validate. Please note you will need to validate your email address before you are able to proceed with making or amending an application.</p>
     {/if}
  
  {#if submittedApplications.length > 0}
  <hr/>
  <div style="padding: 1em;">
    <h1 class="title is-4"> You must resubmit following application(s) </h1>
    {#each submittedApplications as a}
      <p><span style="padding-left:1em;">{a.reference}</span></p>
      <br/>
    {/each}
    <p> Please select "Continue" to carry on making changes to your application or resubmit appication from your home page. </p> 
  </div>
  {/if}

  {#if submittedLateApplications.length > 0}
    <hr/>
    <strong>Local Authorities notified</strong>
    <p>The relevant Local Authorities have been notified about the changes you have made. Please contact the <a href='https://www.eadmissions.org.uk/contact/' target='_blank' style='text-decoration:underline'>Authority</a> if the child has moved home address.</p>
    {#each submittedLateApplications as la}
      <p><span>{la.reference}</span></p>
      <br/>
    {/each}
  {/if}
  </div>
   <footer class="modal-card-foot buttons is-right" slot="footer">
    <button
      class="button continue is-primary"
      on:click={() => {
        showSuccessMessage = false; 
        dispatch("pageChange", "/useraccount/details");       
      }}>
      Continue
    </button>
    {#if submittedApplications.length >0 }
      <button  
        class="button continue is-purple" 
        on:click={()=>{    
          showSuccessMessage = false;
          dispatch('pageChange', '/user/home');
        }
      }>
        Resubmit
      </button>
    {/if}
  </footer>
</Modal>